import { create } from 'zustand';

interface TraceDrawerState {
  isOpen: boolean;
  traceId: string | undefined;
  open: (traceId: string) => void;
  close: () => void;
  toggle: () => void;
}

/**
 * Zustand store for trace drawer visibility state.
 * Separate from URL state to avoid polluting navigation history
 * for transient UI state.
 */
export const useTraceDrawerStore = create<TraceDrawerState>((set, get) => ({
  isOpen: false,
  traceId: undefined,
  open: (traceId: string) => set({ isOpen: true, traceId }),
  close: () => set({ isOpen: false, traceId: undefined }),
  toggle: () => {
    const { isOpen } = get();
    // Only toggle if currently open (to close it)
    // Don't open when toggling from closed state
    if (isOpen) {
      set({ isOpen: false });
    }
  },
}));
